

// AWS Server
const attachmenturl = "https://api.intstudentworld.com";

export default attachmenturl;
